import React from "react";
import { Link } from "react-router-dom";
import { MdOpenInNew } from "react-icons/md";
import { Typography } from "components/Elements";
import Swal from 'sweetalert2';

const QuickLink = ({ link, text }) => {
  const handleLinkClick = () => {
    Swal.fire({
      title: "Feature Coming Soon",
      text: `${text} is not available yet. You can search for form instead and stay tuned for updates!`,
      icon: "info",
      confirmButtonText: "OK",
    });
  };

  return (
    <Link to={link} className="hover:underline flex items-center justify-between" onClick={handleLinkClick}>
      <Typography className="text-gray-800" size="xs">
        {text}
      </Typography>
      <MdOpenInNew className="h-6" />
    </Link>
  );
};

const links = [
  {
    link: "#",
    text: "Certify academic documents",
  },
  {
    link: "#",
    text: "Apply for accreditation",
  },
  {
    link: "#",
    text: "Confirm registration status",
  },
  {
    link: "#",
    text: "Verify your results",
  },
];

export const QuickLinks = () => {
  return (
    <div className="px-3">
      <Typography fontCase="upper" className="font-bold mb-3" variant="danger">
        Quick Links
      </Typography>
      <div className="grid gap-2">
        {links.map((link, index) => (
          <QuickLink key={index} {...link} />
        ))}
      </div>
    </div>
  );
};
